import { SubmitHandler, useForm } from 'react-hook-form';
import { CohortForm, CohortFormData } from './CohortForm';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';
import { useContext, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AdminCohorts } from '@platform/client';
import { AdminTableContext } from '../../AdminTable';

export const CreateCohortModal = ({ onClose }: { onClose: () => void }) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const { ...functions } = useForm<CohortFormData>();
  const queryClient = useQueryClient();
  const createCohortMutator = AdminCohorts.useCreateCohort({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...AdminCohorts.getGetAdminCohortsQueryKey({ ...adminQueryOptionsV2 })],
        });
        setModalStage('success');
      },
    },
  });
  const onSubmit: SubmitHandler<CohortFormData> = async (data) => {
    createCohortMutator.mutate({
      data: {
        name: data.name,
        clientId: parseInt(data.clientId),
        available: data.available ?? false,
        url: data.url ?? null,
        description: data.description ?? null,
        kickoffDate: data.kickoffDate ? data.kickoffDate.toISOString() : null,
        startDate: data.startDate ? data.startDate.toISOString() : null,
        endDate: data.endDate ? data.endDate.toISOString() : null,
        applicationStartDate:
          data.applicationStartDate ? data.applicationStartDate.toISOString() : null,
        applicationEndDate: data.applicationEndDate ? data.applicationEndDate.toISOString() : null,
      },
    });
  };
  return (
    <AdminFormModal
      variant='full-screen'
      title='Create Cohort'
      modalStage={modalStage}
      onClose={onClose}
      submitCTA={{ text: 'Create Cohort', callback: () => functions.handleSubmit(onSubmit)() }}
    >
      <CohortForm {...functions} />
    </AdminFormModal>
  );
};
